import { DataBean } from "../DataBean";

export class CreateProductRow extends DataBean {

    public async createProductRowWithPriceListItem(idMarketPlaceProduct: any, idPriceListItem: any, quantity: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.Product_createProductRowWithPriceListItem_Number_Number_Number", [idMarketPlaceProduct, idPriceListItem, quantity]);
    }

}